export const defaultLocale = {language: 'English', country: 'DEFAULT', isoCode: 'en'};
